<template>
  <div v-if="params.show" class="alert flex_center">
    <div class="popupView">
      <div class="contentView flex_center" v-html="params.message"></div>
      <div class="flex_center">
        <div @click="callbackFail" class="failBtn flex_center">
          취소
        </div>
        <div @click="callbacksuccess" class="confirmBtn flex_center">
          확인
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "confirm"
    ,data(){
      return{
        params:{
          show: false
          , title: ''
          , message: ''
          , success: null
          , fail:null
        }
      }
    }
    ,methods:{
      callbacksuccess(){
        this.params.success();
      }
      ,callbackFail(){
        this.params.fail();
      }
    }
  }
</script>

<style scoped>
  .alert{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.3);
    z-index: 9999;
  }
  .popupView{
    width: 8.333rem;
    background-color: #fff;
    border: 1px solid #b9b9b9;
  }
  .contentView{
    padding: 1.0rem 0.8rem;
    line-height: 1.5;
    text-align: center;
  }

  .confirmBtn,.failBtn{
    width: 50%;
  }

  .confirmBtn{
    height: 1.389rem;
    border-top: 1px solid #eaeaea;
    color: #F15929;
    font-weight: bold;
  }

  .failBtn{
    height: 1.389rem;
    border-top: 1px solid #eaeaea;
    color: #9F9F9F;
    font-weight: bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/confirm.vue